/*=========================================================================================
  File Name: moduleExpenseSettingMutations.js
  Description: Expense Setting Mutations
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  SET_EXPENSE_CATEGORIES_WITH_CHILS(state, payload) {
    state.expense_categories_with_childs = payload;
  },
};
